import Component from '../lib/Component'

export default class VideoPlayer extends Component {
  constructor (elem, APP) {
    super(elem, APP)
    this.playerLoaded = false
    this.poster = this.elem.querySelector('.js-VideoPlayer__poster')
    this.player = this.elem.querySelector('.js-VideoPlayer__player')
    this.videoID = this.videoID = this.elem.getAttribute('data-video-id')
    this.config = this.elem.getAttribute('data-config')
    this.iframeURL = false
  }

  addPlayer () {
    let iframe = document.createElement('iframe')
    iframe.setAttribute('src', this.iframeURL)
    iframe.setAttribute('frameborder', '0')
    iframe.setAttribute('allowfullscreen', '0')
    if (this.poster) {
      this.poster.parentNode.replaceChild(iframe, this.poster)
    } else {
      this.player.prepend(iframe)
    }
  }

  init () {
    this.elem.addEventListener('click', this.addPlayer.bind(this))

    // Detect config
    if (this.config) {
      this.config = JSON.parse(this.config)
      if (this.config.autoPlay) {
        this.addPlayer()
      }
    }
  }
}
